import { render, staticRenderFns } from "./Courses.vue?vue&type=template&id=df394866&scoped=true"
import script from "./Courses.vue?vue&type=script&lang=ts"
export * from "./Courses.vue?vue&type=script&lang=ts"
import style0 from "./Courses.vue?vue&type=style&index=0&id=df394866&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df394866",
  null
  
)

export default component.exports